<div class="p-toolbar">
  <ng-content></ng-content>
  <div class="p-actions-bar">
    <vnm-organization-dropdown
      *ngIf="showOrgSelect$ | async"
      id="globalOrgSelect"
      [topbar]="true"
      label=""
    ></vnm-organization-dropdown>
    <vnm-organization-dropdown
      *ngIf="showOrgInstructorSelect$ | async"
      [topbar]="true"
      [organizations$]="organizationsForInstructor$"
      label=""
    >
    </vnm-organization-dropdown>

    <vnm-shopping-cart-toggle
      *ngIf="showShoppingCartButton$ | async"
      [currentUser]="user$ | async"
      [iconOnly]="true"
      buttonClass="p-button-rounded p-button-text"
    ></vnm-shopping-cart-toggle>
    <vnm-sidebar-toggle
      *ngIf="isTrainingManager$ | async"
      icon="fa fa-fw fa-question-circle"
      label="training-dashboard.faq"
      buttonClass="p-button-text"
    >
      <ng-template #toggle>
        <vnm-support-faq scope="training-manager"></vnm-support-faq>
      </ng-template>
    </vnm-sidebar-toggle>

    <vnm-user-menu></vnm-user-menu>
  </div>
</div>
